// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactDomElement from "./ReactDomElement.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "./ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";

let defaultStyle = {
  backgroundColor: "inherit",
  border: "none",
  color: "inherit",
  cursor: "inherit",
  fontFamily: "inherit",
  fontSize: "inherit"
};

function TextInput(props) {
  let onChange = props.onChange;
  let value = props.value;
  let style = props.style;
  let __autoFocus = props.autoFocus;
  let __secureTextEntry = props.secureTextEntry;
  let __autoTrim = props.autoTrim;
  let __readOnly = props.readOnly;
  let readOnly = __readOnly !== undefined ? __readOnly : false;
  let autoTrim = __autoTrim !== undefined ? __autoTrim : true;
  let secureTextEntry = __secureTextEntry !== undefined ? __secureTextEntry : false;
  let autoFocus = __autoFocus !== undefined ? __autoFocus : false;
  let match = React.useState(() => false);
  let setFocused = match[1];
  let focused = match[0];
  let domRef = Stdlib_Option.getOr(props.inputRef, React.useRef(null));
  React.useEffect(() => {
    let input = domRef.current;
    if (input == null) {
      return;
    }
    if (!autoFocus) {
      return;
    }
    let timeoutId = setTimeout(() => ReactDomElement.focus(input), 75);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [autoFocus]);
  ReactUpdateEffect.use1(() => {
    if (value === undefined) {
      return;
    }
    if (onChange === undefined) {
      return;
    }
    if (!(!focused && autoTrim)) {
      return;
    }
    let trimmedValue = value.trim().replace(/\s+/g, " ");
    if (trimmedValue !== value) {
      onChange(trimmedValue);
    }
  }, [focused]);
  let match$1 = Stdlib_Option.isSome(value) ? [
      undefined,
      value
    ] : [
      value,
      undefined
    ];
  let onFocusChange = React.useCallback(value => setFocused(param => value), []);
  let props_aria$label = "Input";
  let props_placeholder = props.placeholder;
  let props_inputElementType = "input";
  let props_type = secureTextEntry ? "password" : "text";
  let props_maxLength = props.maxLength;
  let props_autoFocus = autoFocus;
  let props_value = match$1[1];
  let props_defaultValue = match$1[0];
  let props_onFocus = props.onFocus;
  let props_onBlur = props.onBlur;
  let props_onFocusChange = onFocusChange;
  let props$1 = {
    "aria-label": props_aria$label,
    placeholder: props_placeholder,
    inputElementType: props_inputElementType,
    type: props_type,
    maxLength: props_maxLength,
    isReadOnly: readOnly,
    autoFocus: props_autoFocus,
    value: props_value,
    defaultValue: props_defaultValue,
    onChange: onChange,
    onFocus: props_onFocus,
    onBlur: props_onBlur,
    onFocusChange: props_onFocusChange
  };
  let match$2 = ReactAria.useTextField(props$1, domRef);
  let props$2 = ReactAria.mergeProps(match$2.inputProps, props.ariaProps);
  let combinedStyle = style !== undefined ? Object.assign({}, defaultStyle, style) : defaultStyle;
  let newrecord = {...props$2};
  return JsxRuntime.jsx("input", (newrecord.style = combinedStyle, newrecord.ref = Primitive_option.some(domRef), newrecord));
}

let make = React.memo(TextInput);

export {
  make,
}
/* make Not a pure module */
